import store from '../store';
import layerManager from './layer.manager';
import * as layerNames from './layerName';
import shareManager from './share.manager';
const actionMap = {
  lookcar: function (data) {
    layerManager.openLookCar(data.param);
  },
  interior: function (data) {
    layerManager.openInterior(data.param);
  },
  config: function (data) {
    layerManager.openConfig(data.param);
  },
  images: function (data) {
    layerManager.openImages(data.param);
  },
  order: function (data) {
    layerManager.openOrder(data.param);
  },
  close: function (data) {
    if (data.param && data.param.type === 'vr3d') {
      layerManager.close3dLayer(false);
    }
  },
  xunjia: function (data) {
    // 3d单车询价
    layerManager.openOrder({
      seriesid: data.seriesId,
      eid: data.eid || '20191115003',
    });
  },
  loaded: function (data) {
    layerManager.layerLoaded(data.param);
  },
  setCurrentScene: function (data) {
    store.commit('scene/setCurrentScene', data.param);
  },
  open3dLayer: function () {
    layerManager.open3dLayer();
  },
  setSceneLoading: function (data) {
    let param = data.param;
    if (!param) {
      return;
    }
    if (param.show === true) {
      store.commit('loading/setLoadStart', { sceneType: 'full' });
    } else {
      store.commit('loading/setLoadComplete', { sceneType: 'full' });
    }
  },
  share: function (data) {
    layerManager.close();
    shareManager.showActivitySharePanel(data.param);
  },
  setThreeDimensionCarSeriesInfo(data) {
    store.commit('frame/setThreeDimensionCarSeriesInfo', data.param);
  },
};
export default {
  reviceMessage: function (event) {
    console.log(event);
    var data = event.data;
    if (!data) {
      return;
    }
    // 3d单车关闭
    if (data === 'close') {
      layerManager.close3dCar();
    } else if (data === 'closeGame') {
      layerManager.close(layerNames.DEALER_ACTIVITY_LAYER);
    } else if (data === 'inputblur') {
      window.scrollTo(
        window.screenX || window.pageXOffset,
        window.scrollY || window.pageYOffset,
      );
    }
    this.processAction(data);
  },
  processAction(data) {
    let action = actionMap[data.action];
    if (action) {
      action(data);
    }
  },
  listen() {
    const self = this;
    window.addEventListener('message', (event) => self.reviceMessage(event));
  },
};
